import { Controller } from "@hotwired/stimulus"
import { formatDecimal, parseDecimal } from "../utils/decimal"

// Live "Zeilensumme" / "Spaltensumme" of a custom_table block in the report form.
// Each row carries its summed number inputs as `cell` targets (data-column-key) and,
// with row totals on, a `rowTotal` target. The footer carries one `columnTotal` per
// summed column and an optional `grandTotal`. Rows deleted through nested-form are
// hidden with _destroy=1 and left out; nested-form then fires `change` on this element.
export default class extends Controller {
  static targets = ["row", "cell", "rowTotal", "columnTotal", "grandTotal"]

  rowTargetConnected() {
    this.recalculate()
  }

  rowTargetDisconnected() {
    this.recalculate()
  }

  recalculate() {
    const columnTotals = {}
    let grandTotal = 0

    this.rowTargets.forEach((row) => {
      if (this.removed(row)) return

      let rowTotal = 0
      row.querySelectorAll("[data-custom-table-totals-target~='cell']").forEach((cell) => {
        const value = parseDecimal(cell.value)
        const key = cell.dataset.columnKey
        columnTotals[key] = (columnTotals[key] || 0) + value
        rowTotal += value
      })
      grandTotal += rowTotal

      const rowTotalCell = row.querySelector("[data-custom-table-totals-target~='rowTotal']")
      if (rowTotalCell) rowTotalCell.textContent = formatDecimal(rowTotal)
    })

    this.columnTotalTargets.forEach((cell) => {
      cell.textContent = formatDecimal(columnTotals[cell.dataset.columnKey] || 0)
    })
    if (this.hasGrandTotalTarget) this.grandTotalTarget.textContent = formatDecimal(grandTotal)
  }

  removed(row) {
    return (
      row.style.display === "none" || row.querySelector("input[name*='_destroy']")?.value === "1"
    )
  }
}
